"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetLastFetched = exports.INBOX_RESET_LAST_FETCHED = void 0;
var INBOX_RESET_LAST_FETCHED = "inbox/RESET_LAST_FETCHED";
exports.INBOX_RESET_LAST_FETCHED = INBOX_RESET_LAST_FETCHED;

var resetLastFetched = function resetLastFetched() {
  return {
    type: INBOX_RESET_LAST_FETCHED
  };
};

exports.resetLastFetched = resetLastFetched;